export const DEAL_LOADING = "DEAL_LOADING";
export const DEAL_RESET = "DEAL_RESET";
export const GET_DEAL = "GET_DEAL";
export const GET_DEAL_SUCCESS = "GET_DEAL_SUCCESS";
export const GET_DEAL_FAIL = "GET_DEAL_FAIL";
export const DELETE_DEAL = "DELETE_DEAL";
export const DELETE_DEAL_SUCCESS = "DELETE_DEAL_SUCCESS";
export const DELETE_DEAL_FAIL = "DELETE_DEAL_FAIL";
export const UPDATE_DEAL = "UPDATE_DEAL";
export const UPDATE_DEAL_SUCCESS = "UPDATE_DEAL_SUCCESS";
export const UPDATE_DEAL_FAIL = "UPDATE_DEAL_FAIL";
export const ADD_NEW_DEAL = "ADD_NEW_DEAL";
export const ADD_DEAL_SUCCESS = "ADD_DEAL_SUCCESS";
export const ADD_DEAL_FAIL = "ADD_DEAL_FAIL";
